import { createFileRoute } from '@tanstack/react-router'

import Statistics from '@/features/Admin/Statistics'

export const Route = createFileRoute('/_authenticated/admin/statistics')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Statistics />
}
